import session from './session'

class BaseAPI {
  constructor (endPoint, baseURL = '/api/v1/main/', config = {}) {
    this.endPoint = endPoint
    this.baseURL = baseURL
    this.config = config
  }

  list () {
    return session.get(`${this.baseURL}${this.endPoint}`, this.config)
  }

  create (data) {
    return session.post(`${this.baseURL}${this.endPoint}`, data, this.config)
  }

  retrieve (id) {
    return session.get(`${this.baseURL}${this.endPoint}${id}/`, this.config)
  }

  update (id, data) {
    return session.put(`${this.baseURL}${this.endPoint}${id}/`, data, this.config)
  }

  partialUpdate (id, data) {
    return session.patch(`${this.baseURL}${this.endPoint}${id}/`, data, this.config)
  }

  destroy (id) {
    return session.delete(`${this.baseURL}${this.endPoint}${id}/`, this.config)
  }
}

export default {
    books: new BaseAPI('book/'),

    checkPriceTour (data) {
        return session.post('/api/v1/tours/check-price-tour', data)
    },
    getTransTour (idTour) {
      return session.get(`/api/v1/tours/trans-tour/${idTour}`)
    }
}